var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chat-tools-container flex justify-between items-center" },
    [
      _c(
        "div",
        { staticClass: "tools-btns" },
        [
          !_vm.getIsShowDouyinBZhangGuide && !_vm.getisDeleted
            ? _c(
                "div",
                { staticClass: "left-fn", on: { click: _vm.restartSession } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/image/aigc/Message-failed.png"),
                      alt: "",
                    },
                  }),
                  _vm._v(" 全新对话 "),
                ]
              )
            : _vm._e(),
          _vm.isLiveAssistant && !_vm.getisDeleted
            ? _c("LiveAssistantButtons", {
                on: { "function-click": _vm.handleFunctionClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }